module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAZCAYAAABzVH1EAAAAAXNSR0IArs4c6QAAAL5JREFUWAnV1UkOgzAQRNHmJOEm8cGy4OKRcRZfIEcWk4dqJFTGbOq5F57M67PE2b4WLKbXLExuHFnxBHjtu+tCDorvEb+1DuRicR3Iw+LjIJWL94M0Lt4O0rl4Pcjg4vchYsXPQ8SLlyHOiv9DPjGkzSVd+e/8p6fv7WZ3P5HSsTuDbRMpgdgXh52HACLFYPchgMjBsHoQQGRnWDsIILIxrB8EEFkZNg4CiHwI04EAIi/CdCGAyAOYHwggMoOtZ16Er2hVAQYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/cursor-left.png
// module id = YhkJ
// module chunks = 1